/*
 * CFS: names the Shopify Forms pop-up's outer dialog (owner, 24 Oct 2026).
 * The Forms app draws its pop-up as two nested role="dialog" sections inside the open shadow root of
 * <shopify-forms-embed>; the inner one has aria-label (the form title), the outer overlay has none,
 * so screen readers announce an unnamed dialog and Lighthouse flags "ARIA dialog and alertdialog
 * nodes should have an accessible name". This copies the inner name (or the form heading) onto any
 * unnamed dialog. It only adds an attribute and does nothing if the markup isn't found, so a change
 * on Shopify's side can't break the form. Remove once Shopify names the dialog itself.
 */
const FALLBACK = 'Sign-up form';

function nameDialogs(root) {
  for (const dialog of root.querySelectorAll('[role="dialog"], [role="alertdialog"]')) {
    if (dialog.hasAttribute('aria-label') || dialog.hasAttribute('aria-labelledby')) continue;
    const inner = dialog.querySelector('[role="dialog"][aria-label], [role="alertdialog"][aria-label]');
    const heading = dialog.querySelector('h1, h2, h3, [role="heading"]');
    const name = inner?.getAttribute('aria-label') || heading?.textContent?.trim() || FALLBACK;
    dialog.setAttribute('aria-label', name);
  }
}

function watch(embed) {
  if (embed.dataset.cfsA11y) return;
  const root = embed.shadowRoot;
  if (!root) return;
  embed.dataset.cfsA11y = '1';
  nameDialogs(root);
  // The pop-up is drawn later (first view, after a delay or on exit intent), so keep watching.
  new MutationObserver(() => nameDialogs(root)).observe(root, { childList: true, subtree: true });
}

function scan() {
  document.querySelectorAll('shopify-forms-embed').forEach(watch);
}

// The embed's shadow root appears once the Forms app script has run; check for a while after load.
let tries = 0;
const timer = setInterval(() => {
  scan();
  if (++tries >= 30) clearInterval(timer);
}, 1000);
scan();
